import types from '../actions/types'

export function showNotification (text, autoHideDuration = 3000, action = null, disableClickAway = false) {
  return {
    type: types.SHOW_NOTIFICATION,
    payload: {
      text,
      autoHideDuration,
      action,
      disableClickAway
    }
  }
}

export function hideNotification () {
  return {
    type: types.HIDE_NOTIFICATION,
    payload: null
  }
}
